export default "__VITE_ASSET__Cf4Hxo8s__"